"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = void 0;
function getValue(data, multiSelection) {
    if (multiSelection === void 0) { multiSelection = false; }
    if (multiSelection && !(data instanceof Array)) {
        return [];
    }
    return data;
}
exports.getValue = getValue;
//# sourceMappingURL=ButtonGroup.interface.js.map